import { Button, Theme, useMediaQuery, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { usePopover } from 'src/hooks/use-popover';
import { useViewContextName } from 'src/hooks/use-view-context-name';
import { Briefcase as BriefcaseIcon } from 'src/icons/briefcase';
import { ChevronDown } from 'src/icons/chevron-down';
import { createOutsideClickHandler } from 'src/utils/create-outside-click-handler';
import { AvailableSitesPopper } from '../molecules/available-sites-popper';

export const SiteSelector = () => {
  const getViewContextName = useViewContextName();

  const {
    palette: { mode },
  } = useTheme();

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  const [
    siteMenuAnchorRef,
    openSiteMenu,
    handleOpenSiteMenu,
    handleCloseSiteMenu,
  ] = usePopover();

  useEffect(() => {
    createOutsideClickHandler([siteMenuAnchorRef], handleCloseSiteMenu);
  }, []);

  return (
    <>
      <Button
        color="primary"
        onClick={openSiteMenu ? handleCloseSiteMenu : handleOpenSiteMenu}
        ref={siteMenuAnchorRef}
        size={isMobile ? 'medium' : 'large'}
        variant="text"
        startIcon={
          <BriefcaseIcon
            fontSize="small"
            sx={{
              color: mode === 'dark' ? '#fff' : '#000',
              width: '16px',
            }}
          />
        }
        endIcon={<ChevronDown fontSize="small" />}
        sx={{
          ml: 1,
          mr: 2,
          alignItems: 'center',
          fontWeight: 400,
          color: 'text.primary',
          '&:hover': {
            color: 'text.primary',
          },
          '&:active': {
            color: 'text.primary',
          },
          '&:focus': {
            color: 'text.primary',
          },
        }}>
        {getViewContextName()}
      </Button>

      <AvailableSitesPopper
        anchorRef={siteMenuAnchorRef}
        open={openSiteMenu}
        onClose={handleCloseSiteMenu}
        placement="bottom-end"
      />
    </>
  );
};
